/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  InternalServerErrorResponse,
  NotFoundResponse,
  TooManyRequestsResponse,
  VersionDTO,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns the current version of the application
 * @summary Returns the version information
 */
export type getBackendVersionResponse = {
  data: VersionDTO;
  status: number;
};

export const getGetBackendVersionUrl = () => {
  return `http://localhost:8080/api/v1/version`;
};

export const getBackendVersion = async (
  options?: RequestInit
): Promise<getBackendVersionResponse> => {
  return customFetchInstance<Promise<getBackendVersionResponse>>(
    getGetBackendVersionUrl(),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetBackendVersionQueryKey = () => {
  return [`http://localhost:8080/api/v1/version`] as const;
};

export const getGetBackendVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBackendVersionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackendVersion>>
  > = ({ signal }) => getBackendVersion({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBackendVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBackendVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackendVersion>>
>;
export type GetBackendVersionQueryError =
  | NotFoundResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetBackendVersion<
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getBackendVersion>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetBackendVersion<
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getBackendVersion>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetBackendVersion<
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns the version information
 */

export function useGetBackendVersion<
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBackendVersionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetBackendVersionSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBackendVersionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackendVersion>>
  > = ({ signal }) => getBackendVersion({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getBackendVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBackendVersionSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackendVersion>>
>;
export type GetBackendVersionSuspenseQueryError =
  | NotFoundResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetBackendVersionSuspense<
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetBackendVersionSuspense<
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetBackendVersionSuspense<
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns the version information
 */

export function useGetBackendVersionSuspense<
  TData = Awaited<ReturnType<typeof getBackendVersion>>,
  TError =
    | NotFoundResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getBackendVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBackendVersionSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
